import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pmui-error-view',
  templateUrl: './error-view.component.html',
  styleUrls: ['./error-view.component.less']
})
export class ErrorViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
